import * as vt from 'vue-toastification';

import type { PluginOptions } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

export default defineNuxtPlugin((nuxtApp) => {
  const options: PluginOptions = {
    position: vt.POSITION.TOP_CENTER,
    timeout: 4000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    closeButton: false,
    hideProgressBar: true,
    icon: true,
    toastClassName: 'main-toast',
  };
  nuxtApp.vueApp.use(vt.default, options);
  return {
    provide: {
      toast: vt.useToast(),
    },
  };
});
